import { Component, ComponentFactoryResolver, EventEmitter, HostListener, Input, OnInit, Output, Type, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { alert, custom } from 'devextreme/ui/dialog';
import { messagefromComponent } from '../../class/appinterface';
import { NicaInfoAnagraficaAziendaComponent } from '../anagrafiche/nica-info-anagrafica-azienda/nica-info-anagrafica-azienda.component';
import { NicaDynamicContentComponent } from '../nica-dynamic-content/nica-dynamic-content.component';
import { NicaFormComponent } from '../nica-form/nica-form.component';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { NicaMapsComponent } from '../../widgets/nica-maps/nica-maps.component';
import notify from 'devextreme/ui/notify';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { NewNicaFormComponent } from '../nica-form/new-nica-form.component';
import { filter } from 'rxjs-compat/operator/filter';
import { ModelliStampaService } from '../../services/modelli-stampa.service';



@Component({
  selector: 'app-master-component',
  template: '',
  styleUrls: ['./nica-master.component.css'],

})


export class NicaMaster {
  @ViewChild('formSoggetto', { static: false }) formSoggetto: NicaFormComponent;
  @ViewChild('formAnagrafica', { static: false }) formAnagrafica: NewNicaFormComponent;
  @ViewChild('dynamicComponent', { static: false }) dynamicComponent: NicaDynamicContentComponent;
  @ViewChild('nicaAnagrafica', { static: false }) nicaAnagrafica: NicaAnagraficaComponent;

  @Input() itemData: any
  @Input() InviaA: any
  @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>();


  showFormEdit: boolean = false
  masterKey: any;

  CustomButtonSetForm: {};
  myButtonCustom: {};
  apiset: string;
  id: string;
  filterID: any = [];
  SubjectCall: string;
  queryString: string;
  type: string;
  template: string
  /**Related TABLE**/
  relApiset: string;
  relFilter: string;
  rowData: any[] = [];
  thisVisible: boolean = false;
  serviceButtonsArray: any[] = []
  buttonToolbarUp?: any[] = [];
  buttonToolbarBottom?: any[] = [];
  nCol: number = 2;
  toolbarComponentFilter: any;
  ngClass: string;
  currentTabId: any;
  currentTabName: any;
  anaData: any;
  isOpen: boolean = false;
  InAttesaOpen = false;
  anagraficaDati: any[] = [];
  titleDynamic: string;
  timeInterval: any
  currentElement: any[];
  queryFilter: any[] = [];
  protected previusUrl: string;
  showToolBar: boolean = false;
  tempData: any[];
  flag: boolean = false;
  helpDoc: any;
  breadcrumbCaption: any;
  returnUrl: string;
  params: any;
  filterGrid: string = '';
  cronNavigation: any[] = [];
  campo: any
  idBreadcrumbGroup: any= null;
  breadcrumbNavigation: any[] = [];
  filterKey: any;
  //popupVisibleForm: boolean = false
  pulsantiOpzionaliSede: any[];
  showToolbarC: boolean = true
  buttonToolbarBottomGrid: any[];
  tabNavigationChildrend: any;
  backgroundToolbar: string = '#337ab7'
  textColorToolbar: string = '#fff'
  cssClass: string = ''
  allowedAdvancedFilter?: boolean;
  advancedXlsExportFilterTemplateName?: string;
  isAdvancedXlsExportAvailable?: boolean;
  bakgroundToolbar: string = "#337ab7"; //'#045072'
  constructor(
    public userComponentService?: ComponentService,
    public templateService?: FormsTemplateService,
    public _overlaySideFormService?: OverlaySideFormService,
    public _overlaySidePanelService?: OverlaySideFormService,
    public formTemplateService?: FormsTemplateService,
    public _componentFactoryResolver?: ComponentFactoryResolver,
    public activatedroute?: ActivatedRoute,
    public router?: Router,
    public menuService?: NicaMenuService,
    public rentriService?: RentriService,
    public anagraficaService?: AnagraficaService,
    public modelliStampaService?: ModelliStampaService,
    public loader?: NgxSpinnerService
  ) {}

  /*
  ngAfterContentChecked(): void {

  }
  ngAfterContentInit(): void {
    throw new Error('Method not implemented.');
  }
  */
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event) {
    ////console.log(event)
    if (event.code == 'F1') {
      event.preventDefault();
      let data = []
      this.refreshPage(data, 'Elenco', this.SubjectCall, 'grid');
      event.stopImmediatePropagation();

    }

    if (event.code == 'F4') {
      event.preventDefault();
      let data = []
      this.refreshPage(data, 'Elenco', this.SubjectCall, 'form');
      event.stopImmediatePropagation();

    }

    if (event.code == 'F10') {

      this.formAnagrafica.onFormSubmit();
      event.preventDefault();
      event.stopImmediatePropagation();

    }
    /* if (event.code == 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      const prevNav = this.userComponentService.getPrevItemComponentNavigation(this.SubjectCall, this.currentTabId);


      const navigationParams = prevNav.params
      this.router.navigate(['/'], {
        skipLocationChange: true,
        replaceUrl: true
      }).then(() => {
        // Forzo a naviagare verso questa url per aggiornare i dati. 

        //sono costretto a ricaricare in maniera forzata il componente in attesa di idee
        let navigationExtras: NavigationExtras = {
          queryParams: navigationParams, skipLocationChange: true,
          replaceUrl: true
        };
        this.router.navigate([prevNav.cRouter], navigationExtras);


        //this.userComponentService.removeItemComponentNavigation(this.SubjectCall, this.currentTabId)
      })
    } */
    /* if (event.code == 'End') {
      let e = {
        name: 'return'
      }

      this.formEvent(e)
    } */
  }

  ngAfterViewInit() {



    /*  if (this.buttonToolbarBottom.length <= 0 && this.buttonToolbarUp.length <= 0) {
       this.showToolBar = false
     }
  */


  }

  ngOnInit() {


    if (typeof this.itemData != undefined) {

      
    } else {
      ////console.log('url',this.router.url)
      this.activatedroute.queryParams
        .subscribe(params => {
          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName


          this.showToolBar = false//Per ora ...

          this.setGlobalVariableFromParams(params);




        });

    }



  }

  setGlobalVariable(itemData) {

    /*
      id: id,
      api: api,
      service: service,
      masterKey: 'id',
      filter: filter,
      descEvent: descEvent,
      templateView: template,
      titoloDaPortare: titoloDaPortare,
      data: dataToSend,
      prevUrl: this.previusUrl,
      currentTabId: this.currentTabId,
      currentTabName: this.currentTabName,
      componentName: componentName

    
    */


    this.apiset = itemData[0].api;
    this.id = itemData[0].id;
    this.queryString = itemData[0].queryString
    this.rowData = itemData[0].dati
    this.template = itemData[0].template
    this.masterKey = itemData[0].masterKey
    this.type = itemData[0].tipo
    this.SubjectCall = itemData[0].SubjectCall;
    this.InviaA = itemData[0].inviaA;
    this.toolbarComponentFilter = itemData[0].toolbarComponent
    this.filterID = JSON.parse(itemData[0].filter);
    this.cssClass = itemData[0].cssClass
    //this.prevUrl= this.previusUrl,
    this.currentTabId = itemData[0].currentTabId;
    this.currentTabName = itemData[0].currentTabName;

    // this.componentName = itemData[0].componentName
  }

  impostaDatiForm(routerParam,anagraficaFilter){
    //Costrusco i dati costanti da inviare alla form.

    let data
    if (routerParam.filter) {

      data = JSON.parse(routerParam.filter);
      ////console.log('routerParamData', data)
      if (anagraficaFilter[0]['configuration']['idTabRif']) {
        let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']

        arrayIdRif.forEach(idTab => {
          if (typeof data[idTab['value']] != 'undefined') {
            this.rowData[idTab['key']] = data[idTab['value']];
          }


        });

      }

      //console.log('rowData', this.rowData)
    }
  }

  private impostaFiltroForm(routerParam,filterEditor){
    if (filterEditor.includes('$')) {

      /*if (this.id != '' && typeof this.id != 'undefined') {
        this.queryString = filterEditor.replace('$', this.id)
      } */
      this.queryString = filterEditor;

      let espressioneVariabile = /\$\w+/mg;

      // Verifica se nella stringa sono presenti altre variabili oltre a $id
      if (espressioneVariabile.test(filterEditor)) {
        //Se sta in ro
        let rowData = this.rowData

        for(let x in rowData){
          if(typeof rowData[x] != 'undefined'){
            if(rowData[x]){
              this.queryString = this.queryString.replace(`$${x}`, rowData[x])
            }

          }
        }
        let filterID = this.filterID
        for(let xx in filterID){
          if(typeof filterID[xx] != 'undefined'){
            if(filterID[xx]){
              this.queryString = this.queryString.replace(`$${xx}`, filterID[xx])
            }

          }
        }
       
      } else {

        let espressioneRegolare = /\$/; 
        let nuovaStringa = filterEditor.replace(espressioneRegolare, this.id);
        this.queryString = nuovaStringa;

      }
    }
  }

  /** Imposta Titolo Griglia */
  private impostaTitoloGriglia(routerParam: any, anagraficaFilter: any[]): void {



    let descEvent = routerParam.descEvent ? routerParam.descEvent : '';
    let keysTitleDaPortare = []
    if (anagraficaFilter[0]['configuration']['campoTitle']) {
      keysTitleDaPortare = anagraficaFilter[0]['configuration']['campoTitle'];
    }

    let titleGriglia = anagraficaFilter[0]['configuration']['titleGriglia']

    keysTitleDaPortare.forEach(keyTitleDaPortare => {
      if (this.filterID[keyTitleDaPortare]) {
        let data = this.filterID[keyTitleDaPortare];;
        let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
        let isMatch = dateType.test(data);

        if (isMatch) {
          let date = new Date(data)
          let month = date.getMonth();
          month = month + 1
          let day = date.getDate().toString().padStart(2, '0');
          data = day + '-' + month + '-' + date.getFullYear()
        }

        if (titleGriglia.includes(keyTitleDaPortare)) {
          titleGriglia = titleGriglia.replace(keyTitleDaPortare, data)
        }

        //titleGriglia = titleGriglia.replace(keyTitleDaPortare, data)
      }
    })

    this.titleDynamic = titleGriglia;

    if (this.template == 'dynamicGrid') {

      this.setVariableDynamicGrid();
      //this.SetToolbarButtons();
    }

    this.filterID['isEdit'] = false

    /*******************************************************/



  }

  /** Imposta Titolo Form */
  impostaTitoloForm(anagraficaFilter: any[]): void {

    //let descEvent = routerParam.descEvent ? routerParam.descEvent : ''
    let keysTitleDaPortare = anagraficaFilter[0]['configuration']['campoTitle'] ? anagraficaFilter[0]['configuration']['campoTitle'] : [];

    let titleDaPortare = '';

    let titleForm = anagraficaFilter[0]['configuration']['titleForm']

    keysTitleDaPortare.forEach(keyTitleDaPortare => {
      if (this.filterID[keyTitleDaPortare]) {
        let data = this.filterID[keyTitleDaPortare];;
        let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
        let isMatch = dateType.test(data);

        if (isMatch) {
          let date = new Date(data)
          let month = date.getMonth();
          month = month + 1
          let day = date.getDate().toString().padStart(2, '0');
          data = day + '-' + month + '-' + date.getFullYear()
        }


        titleForm = titleForm.replace(keyTitleDaPortare, data)
      } else {
        titleForm = titleForm.replace(keyTitleDaPortare, '')
      }
    })

    this.titleDynamic = titleForm;


    if (typeof this.id == 'undefined' || this.id == '') {
      ////console.log('SetToolbarButtons', this.serviceButtonsArray)
      //this.SetToolbarButtons()
    }

  }


  /** Genera il filtro QueryString per la Griglia */

  public impostaFiltroGriglia(routerParam: any, anagraficaFilter: any[]): void {



    /* if (this.queryString != '') {

      let queryString = this.queryString;

      // Crea un'espressione regolare per cercare "$filter=(...)"
      let regexFilter = /\$filter=\([^)]*\)/;

      // Esegui la ricerca nella stringa
      let matchFilter = queryString.match(regexFilter);

      // Verifica se c'è una corrispondenza
      if (matchFilter) {

        let parteSenzaFilter = matchFilter[0].replace(/\$filter=/, '');
        // Oppure, se vuoi rimuovere solo la parte ?$filter= 
        //console.log("Trovato:", parteSenzaFilter);

        this.filterOdata = parteSenzaFilter;

        queryString = queryString.replace(matchFilter[0],'');
        this.queryString = queryString
      }

      if (this.queryString.includes('$')) {
        for (let x in this.dataJson) {
          if (queryString.includes(x)) {
            let regex = new RegExp('\\$' + x + '\\b', 'g');
            queryString = queryString.replace(regex, this.dataJson[x]);
            //queryString = queryString.replace('$' + x, this.dataJson[x]);

          }
        }
        this.queryString = queryString
      }
    } */

    ///Questa è una pezza ma non mi piace devo farla bene:

    if (this.filterGrid != '' && typeof this.itemData != 'undefined') {
      return
    }


    let filterList = anagraficaFilter[0]['configuration']['filterList'];

    if (typeof filterList == "undefined")
      return;
    
    //console.log('prima:', this.filterGrid);

    


    //console.log('prima:', this.filterGrid);

    if (filterList.includes('$')) {
      
      const oDataKeyWords : any[]= [/\$filter/gi,/\$top/gi,/\$skip/gi,/\$orderby/gi,/\$count/gi ];

      //SE NON È PRESENTE ALCUN ODATA MA SOLO LE VARIABILI DA RIMPIAZZARE
      
      if((oDataKeyWords.every(x=> ((filterList as string).match(x)) == null) )){

        const arrayFilterList = filterList.split('$');

        let matchesFilter = ''


          //let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']
          arrayFilterList.forEach(keyRif => {

            console.log(this.filterID)

            const keyRef_WithoutSpecialCharacters = (keyRif as string).replace(/[=?]/g,'');


            if (this.filterID[keyRef_WithoutSpecialCharacters]) {

              let data = this.filterID[keyRef_WithoutSpecialCharacters];

              try {
                matchesFilter = filterList.replace('$' + keyRef_WithoutSpecialCharacters, data);
              } catch (error) {
                console.error('ERRORE: ', error)
                ////console.log('FilterID: ', this.filterID)
              }



            }
          });

          this.filterGrid = matchesFilter;

    
      }
      else{

        //Se è ODATA ANCHE Con altre semplici associazioni chiavi valore in query string
        let parameters = (filterList as string).split('&');

        let tempQueryString = "";


        let noFilter = oDataKeyWords.slice(1,oDataKeyWords.length);

        for(let param of parameters){

          let p = param;

          //tutte le keyword tranne $filter verranno semplicemente aggiunte cosi come sono
          if(noFilter.some(reg => p.match(reg) != undefined)){

            tempQueryString+=`${p}&`;

            continue;
          }

          console.log(this.filterID);

          
          for(let key of Object.keys(this.filterID)){
            
            
            //console.log(key,this.filterID[key]);

            if(typeof this.filterID[key] !== 'undefined' && param.includes(`$${key}`))
              p = param.replace(`$${key}`,this.filterID[key] as string);
           


          }
          

            
          tempQueryString += `${p}&`;



        }


        this.filterGrid = tempQueryString;

      }
    }
    else{

          this.filterGrid = filterList;

    }
    
    


    
      /*
      else{

      let regExp = /\(([^)]+)\)/;
      let matches = regExp.exec(filterList);

      //matches[1] contains the value between the parentheses
      if (matches) {
        let matchesFilter = ''
        if (matches[1].includes('$')) {
          const arrayFilterList = matches[1].split('$');

          //let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']
          arrayFilterList.forEach(keyRif => {
            //////console.log(keyRif)
            if (this.filterID[keyRif]) {
              let data = this.filterID[keyRif];

              try {
                matchesFilter = filterList.replace('$' + keyRif, data);
              } catch (error) {
                console.error('ERRORE: ', error)
                ////console.log('FilterID: ', this.filterID)
              }



            }
          })

          this.filterGrid = matchesFilter;

        }
      } else {
        if (filterList.includes('$')) {
          const arrayFilterList = filterList.split('$');

          //let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']
          arrayFilterList.forEach(keyRif => {
            //////console.log(keyRif)
            if (this.filterID[keyRif]) {
              let data = this.filterID[keyRif];

              try {
                filterList = filterList.replace('$' + keyRif, data);
                this.filterGrid = filterList;
              } catch (error) {
                console.error('ERRORE: ', error)
                ////console.log('FilterID: ', this.filterID)
              }



            }
          })



        }

      }


    }

    if (routerParam.queryFilter) {
      if (anagraficaFilter[0]['configuration']['queryFilter']) {
        let arrayQueryFilter = anagraficaFilter[0]['configuration']['queryFilter']

        let newItemQ = ''
        let dataQueryFilter = JSON.parse(routerParam.queryFilter)

        arrayQueryFilter.forEach(idTab => {
          if (typeof dataQueryFilter[idTab['key']] != 'undefined') {
            newItemQ += idTab['key'] + '=' + dataQueryFilter[idTab['key']] + '&';

            ////////console.log(idTab['key'] + '=' + dataQueryFilter[idTab['key']])
          }
        });



        if (newItemQ) {
          this.filterGrid = '?' + newItemQ
        }
      }

    }

    if (routerParam.staticQueryFilter) {
      this.filterGrid += routerParam.staticQueryFilter


    }
    */

    




  }


  setGlobalVariableFromParams(routerParam) {

    this.menuService.previousUrl$.subscribe(prevUrl => {

      this.returnUrl = prevUrl
    })


    this.params = routerParam

    this.currentTabId = routerParam.currentTabId,
    this.currentTabName = routerParam.currentTabName




    this.previusUrl = routerParam.prevUrl

    this.anagraficaDati = this.templateService.getService(routerParam.service);

    if (!this.anagraficaDati) {
      if (routerParam.service) {
        this.SubjectCall = routerParam.service
      }

      return
    }
    /**Setto le Variabili globali dalla conFigurazione dell'anagrafica***/

    const anagraficaFilter = this.anagraficaDati.filter(r => r.configuration);
    this.apiset = anagraficaFilter[0]['configuration']['api'];
    this.SubjectCall = anagraficaFilter[0]['configuration']['service']
    this.type = anagraficaFilter[0]['configuration']['formType'];
    this.nCol = anagraficaFilter[0]['configuration']['nCol'];

    this.allowedAdvancedFilter = anagraficaFilter[0]['configuration']['allowedAdvancedFilter'];
    this.advancedXlsExportFilterTemplateName = anagraficaFilter[0]['configuration']['advancedXlsExportFilterTemplateName'];
    this.isAdvancedXlsExportAvailable = anagraficaFilter[0]['configuration']['isAdvancedXlsExportAvailable'];

    /* Ottengo in nome del servizio legato alla toolbar */
    this.toolbarComponentFilter = anagraficaFilter[0]['configuration']['toolbarSettings'];

    /*
       Ottengo in nome del servizio legato alla Tipo di template dai paramenti,se non è settato utilizzo quello della configurazione 
       presente nell'anagrafica.
     */


    if (routerParam.templateView) {
      this.template = routerParam.templateView;

    } else {
      if (!this.anagraficaDati[0]['configuration']['template'] && !this.anagraficaDati[0]['configuration']['startTemplate']) {
        this.template = 'grid'
      } else {
        this.template = this.anagraficaDati[0]['configuration']['template'] || this.anagraficaDati[0]['configuration']['startTemplate']
      }

    }


    /* Ottengo l'oggetto contente i bottoni della toobar */
    if (typeof this.toolbarComponentFilter != 'undefined') {

      this.serviceButtonsArray = this.anagraficaService.getService(this.toolbarComponentFilter.service);
    }


    /* Setto i filtri globali che arrivano dali paramentri */

    if (routerParam.filter) {
      if(routerParam.filter){
        this.filterID = JSON.parse(routerParam.filter);
      }
        

      NicaFormComponent.formDataBackupObject = JSON.parse(JSON.stringify(this.filterID));

    }


    if (routerParam.id) {

      this.id = routerParam.id

    }

    /* 
  
      Se il template è di tipo Griglia o gli dynamicgrid costrusco i paramentri path o qstring per ottenere l'elenco/lista dei dati
      via API 
  
    */


    if (this.template == 'grid' || this.template == 'dynamicGrid') {


      this.impostaFiltroGriglia(routerParam, anagraficaFilter);
      this.impostaTitoloGriglia(routerParam, anagraficaFilter);



    } else  if (this.template == 'form' || this.template == 'component') {
      //Costrusco i dati costanti da inviare alla form.
      this.impostaDatiForm(routerParam, anagraficaFilter)

      let filterEditor = anagraficaFilter[0]['configuration']['filterEditor'];

      this.impostaFiltroForm(routerParam,filterEditor)
      
    }

    this.masterKey = anagraficaFilter[0]['configuration']['masterKey'];

    if (anagraficaFilter[0]['configuration']['helpDoc']) {
      this.helpDoc = anagraficaFilter[0]['configuration']['helpDoc']
    }


    /*
      Se il template è di tipo form, ottengo i dati 
    */

    if (this.template == 'form' || this.template == 'component') {
      
      this.impostaTitoloForm(anagraficaFilter);

    }

    if (routerParam.breadcrumb) {
      this.breadcrumbCaption = routerParam.breadcrumb;

    } else {
      this.breadcrumbCaption = anagraficaFilter[0]['configuration']['breadcrumbCaption'];
      this.idBreadcrumbGroup = anagraficaFilter[0]['configuration']['idBreadcrumbGroup'];
    }

    

    if (routerParam.queryFilter) {

      this.queryFilter = JSON.parse(routerParam.queryFilter);

    }

    let navComponent = sessionStorage.getItem('navComponent')

    if (navComponent) {

      this.cronNavigation = JSON.parse(navComponent);
      this.userComponentService.setNavComponent(this.cronNavigation)

    }

    this.userComponentService.componentRouter.forEach(res => {

      if (Array.isArray(res) && res.length > 0) {
        this.cronNavigation = res.filter(res => res.idTab == routerParam.currentTabId)
      }

    })

    if (this.cronNavigation.length > 0) {

      let navigations = this.cronNavigation.filter(res => res.idTab == this.currentTabId)
      let navigation = navigations[0].data;

      let checkItemIdex = navigation.findIndex(n => n.id == this.idBreadcrumbGroup);

      if (checkItemIdex == -1) {

        let nav = {
          title: this.breadcrumbCaption,
          cRouter: this.router.url.split('?')[0],
          params: this.params,
          idGroup: this.idBreadcrumbGroup,
          idTab: this.currentTabId,
          idData: this.SubjectCall,
          active: true,

        }
        this.userComponentService.setComponentNavigation(nav);
      } else {

        let itemDataNav = {
          title: this.breadcrumbCaption,
          cRouter: this.router.url.split('?')[0],
          params: this.params,
          idGroup: this.idBreadcrumbGroup,
          idTab: this.currentTabId,
          idData: this.SubjectCall,
          active: true,

        }
        this.userComponentService.setNavigationChildren(itemDataNav, this.idBreadcrumbGroup);
      }

    } else {

      let nav = {
        title: this.breadcrumbCaption,
        cRouter: this.router.url.split('?')[0],
        params: this.params,
        idGroup: this.idBreadcrumbGroup,
        idTab: this.currentTabId,
        idData: this.SubjectCall,
        active: true,
        items: []
      }



      this.userComponentService.setComponentNavigation(nav)
    }

    let navigationData = []


    const navigationsFilter = this.cronNavigation.filter(res => res.idTab == this.currentTabId)
    if (navigationsFilter.length > 0) {
      let navigationData = navigationsFilter[0].data;

      this.breadcrumbNavigation = navigationData;

      //console.log('breadcrumbNavigation', this.breadcrumbNavigation)
      this.tabNavigationChildrend = navigationData.filter(res => res.idGroup == this.idBreadcrumbGroup)
    }


    //16 = è l'id del Bottone Ritorna della toolbar di Alessandro

    this.buttonToolbarBottomGrid = [16] /* [
      {
        id: 1,
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        useSubmitBehavior: true,
        template: false,
        options:
        {
          stylingMode: "text",
          text: "Indietro" ,
          icon: "glyphicon icon-annulla-form",
          visible: typeof this.itemData != 'undefined' ? false : true, //pezzottissimo
          onClick: ($event) => {


            //this.emettiChiusuraCaption('close');

            this.returnPrevUrl()
          },


        }


      },
      {
        id: 2,
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        useSubmitBehavior: true,
        template: false,
        options:
        {
          stylingMode: "text",
          text: 'Chiudi tutto',
          icon: "close",
          visible: false,
          onClick: ($event) => {




            this.emettiChiusuraCaption('close')
          },


        }


      },




    ]
 */


  }


  onBreadCrumbCaptionClicked(evt) {

    this.loader.show();

    console.warn(evt);

    this.loader.hide();


  }

  optionalButtonClick(em) {



    if (em.infoButton == 'grigliaDropDownButtonInit') {

      const buttons = em.buttons;
      const dataGrid = em.data;
      const componentMenu = em.componentMenu;

      this.SetToolbarButtons(buttons, dataGrid, componentMenu, em.componentDrop, true);




      return;

    }

    if (em.infoButton.event == 1) {
      let data =
        [{
          idTabRif: em.datiGriglia.id,
          nomeTabRif: em.infoButton.costantValue,
          dati: em.datiGriglia,
          value: em.infoButton.value,
          infoButton: em.infoButton
        }]
      this.openFunction(data);
    }

    if (em.infoButton.event == 2) {
      alert('Funzione non disponibile, in lavorazione', 'Attenzione!')
    }


    if (em.infoButton.event == 3) {



      let template = em.value;
      let currentElement = em.datiGriglia;
      let dataSource;
      let event = 'Elenco'
      ////console.log('BottoneCLiccato', em)
      this.cronNavigation[0].data.forEach(nav => {

        if (nav.id == em.infoButton.dataSource && em.infoButton.value != 'dynamicGrid') {
          template = 'form';
          currentElement = JSON.parse(nav.params.data);
          event = 'Modifica'

        }
        if (nav.items) {
          let items = nav.items;
          items.forEach(item => {
            if (item.id == em.infoButton.dataSource && em.infoButton.value != 'dynamicGrid') {
              ////console.log('cronNavigationitems', item)
              template = 'form';
              currentElement = JSON.parse(item.params.data);
              event = 'Modifica'
            }
          })
        }
      })

      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof currentElement[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: currentElement[idTab['value']] };
            this.filterID = newItem;
          }
        });

      }


      const componentName = em.infoButton.componentName

      this.refreshPage(currentElement, 'Elenco', em.infoButton.dataSource, em.infoButton.value, '', componentName);



    }



    if (em.infoButton.event == 4) {

      let datajS
      if (em.infoButton.costantValue) {

        let currentElement = em.datiGriglia
        const costantValue = em.infoButton.costantValue

        costantValue.forEach(res => {
          datajS = {
            ...datajS, [res['key']]: currentElement[res['value']],
          }
        })

      }

      this.router.navigate(
        [em.infoButton.path],
        {
          queryParams:
          {
            id: em.infoButton.service,

            masterKey: 'id',
            filter: JSON.stringify(this.params.filter),
            data: JSON.stringify(datajS),
            currentTabId: em.infoButton.service,
            currentTabName: em.infoButton.name,
            componentName: em.infoButton.componentName
          },
          skipLocationChange: true,
          replaceUrl: false
        }
      ).then(res => {

      })

    }
  }

  optionalButtonClickToolBar(e) {
    ////console.log('optionalButtonClickToolBar', e);

    switch (e) {
      case 1:

        if (this.filterGrid.includes('?TipoAttivita=P')) {
          this.filterGrid = this.filterGrid.replace('?TipoAttivita=P', '');
          this.nicaAnagrafica.refresh();

          let allElm = document.querySelectorAll(".dx-state-selected");

          allElm.forEach(el => {
            el.classList.remove('dx-state-selected')
          })

          return
        } else if (this.filterGrid.includes('?TipoAttivita')) {
          this.filterGrid = this.filterGrid.split('?')[0];
        }

        const currentFilterGridProd = this.filterGrid;

        this.filterGrid = currentFilterGridProd + '?TipoAttivita=P';

        this.nicaAnagrafica.refresh();

        break;

      case 2:

        if (this.filterGrid.includes('?TipoAttivita=T')) {
          this.filterGrid = this.filterGrid.replace('?TipoAttivita=T', '');
          this.nicaAnagrafica.refresh();
          let allElm = document.querySelectorAll(".dx-state-selected");

          allElm.forEach(el => {
            el.classList.remove('dx-state-selected')
          })
          return
        } else if (this.filterGrid.includes('?TipoAttivita')) {
          this.filterGrid = this.filterGrid.split('?')[0];
        }

        const currentFilterGridTr = this.filterGrid;

        this.filterGrid = currentFilterGridTr + '?TipoAttivita=T';

        this.nicaAnagrafica.refresh();

        break;
      case 3:

        if (this.filterGrid.includes('?TipoAttivita=S')) {
          this.filterGrid = this.filterGrid.replace('?TipoAttivita=S', '');
          this.nicaAnagrafica.refresh();

          let allElm = document.querySelectorAll(".dx-state-selected");

          allElm.forEach(el => {
            el.classList.remove('dx-state-selected')
          })
          return
        } else if (this.filterGrid.includes('?TipoAttivita')) {
          this.filterGrid = this.filterGrid.split('?')[0];
        }

        const currentFilterGridDest = this.filterGrid;

        this.filterGrid = currentFilterGridDest + '?TipoAttivita=S';

        this.nicaAnagrafica.refresh();

        break;
      case 4:

        if (this.filterGrid.includes('?TipoAttivita=I')) {
          this.filterGrid = this.filterGrid.replace('?TipoAttivita=I', '');
          this.nicaAnagrafica.refresh();
          let allElm = document.querySelectorAll(".dx-state-selected");

          allElm.forEach(el => {
            el.classList.remove('dx-state-selected')
          })
          return
        } else if (this.filterGrid.includes('?TipoAttivita')) {
          this.filterGrid = this.filterGrid.split('?')[0];
        }

        const currentFilterGridIn = this.filterGrid;

        this.filterGrid = currentFilterGridIn + '?TipoAttivita=I';

        this.nicaAnagrafica.refresh();

        break;
      case 5:

        if (this.filterGrid.includes('?TipoAttivita')) {
          this.filterGrid = this.filterGrid.split('?')[0];
        }
        this.nicaAnagrafica.refresh();

        let allElm = document.querySelectorAll(".dx-state-selected");

        allElm.forEach(el => {
          el.classList.remove('dx-state-selected')
        })

        break;
      default:

        break;
    }
  }

  evalIII = (dataCheck, cond, value) => {
    let returned: boolean
    switch (cond) {
      case '==':
        if (dataCheck == value) {
          returned = true
        } else {
          returned = false
        };

        break;
      case '>':
        if (dataCheck > value) {
          returned = true
        } else {
          returned = false
        }
        break;
      case '<':
        if (dataCheck < value) {
          returned = true
        } else {
          returned = false
        }
        break;
      case '!=':
        if (dataCheck != value) {
          returned = true
        } else {
          returned = false
        }
        break;
      default:
        returned = false
        break;
    }
    return returned

  }

  SetToolbarButtons(buttons = [], dataGrid = null, component?, component2?, forceShow?) {

    let buttonArray = [];
    let newButton = []
    buttonArray = buttons

    if (this.serviceButtonsArray) {
      buttonArray = this.serviceButtonsArray
    } else {
      buttonArray = buttons
    }

    buttonArray.forEach((button, i) => {
      button.text = button.text ? button.text : button.name
      if (button.location == 'top') {



        if (typeof button['buttonSettings'] != 'undefined') {
          let arrayCondition = button['buttonSettings']['displayButtons']['arrayCondition'];

          let formData

          if (dataGrid) {
            formData = dataGrid
          } else {
            formData = this.filterID;
          }


          let conditions = '';
          let operatorEnd = '&&';
          if (typeof button['buttonSettings']['displayButtons']['typeOfConditions'] != 'undefined') {
            operatorEnd = button['buttonSettings']['displayButtons']['typeOfConditions'];
          }

          const countConditions = arrayCondition.length - 1

          arrayCondition.forEach((condition, x) => {
            let key = condition.key;
            let conditionOperator = condition.operator;
            let value = condition.value;

            let operator = x < countConditions ? operatorEnd : ''
            if (typeof formData[key] == 'undefined') {
              conditions += false
            } else {
              let cond = this.evalIII(formData[key], conditionOperator, value);
              conditions += cond + operator;
            }


          })

          try {
            if (eval(conditions)) {

              button.visible = true
            } else {
              button.visible = false
            }

            if (!button.widget) {
              button.widget = 'button'
            }
          } catch (ex) {

            console.warn(ex);
          }
        }


      }


    })

    this.buttonToolbarUp = buttonArray.filter(buttons => buttons.location == 'top');
    this.buttonToolbarBottom = buttonArray.filter(buttons => buttons.location == 'bottom');


    if (this.template == 'form' || this.template == 'dynamicGrid' || forceShow) {
      this.showToolBar = true
    }
    if (this.template == 'grid') {

      //this.showToolBar = true
    }

  }


  public inizializza(): void {

    this.apiset = this.itemData[0].NomeTabella;
    this.id = this.itemData[0].IdTabella;
    this.rowData = this.itemData[0].data

    this.SubjectCall = 'soggettoForm';

    //////////console.log)
    //this.formSoggetto.initialize();

  }


  formEvent(e) {



    if (e.name == 'infoCF' || e.name == 'infoPiva') {
      let current
      if (e.name == 'infoCF') {
        current = e.data.codiceFiscale.trim();
      }
      if (e.name == 'infoPiva') {
        current = e.data.partitaIVA.trim();
      }


      this._overlaySidePanelService.setTitle("Info dati  fiscali azienda");
      let data = [
        {
          destComponent: 'AnaSoggetto',
          traceMessage: 'infoCF',
          dati: current,

        }
      ]
      this._overlaySidePanelService.sendDataToComponent(data);
      this._overlaySidePanelService.setToolBarVisible(false)
      this._overlaySidePanelService.setContent(NicaInfoAnagraficaAziendaComponent);

      this._overlaySidePanelService.setPopupHeight('60vh');
      this._overlaySidePanelService.setPopupWidth('60vw');



      this._overlaySidePanelService.show();


      setTimeout(() => {


        this._overlaySideFormService._hrefComponent.instance.class = 'soggetto-form';



        (this._overlaySideFormService._hrefComponent.instance.emittedData as EventEmitter<any>).subscribe(ress => {

          ////console.log('emittedData', ress);


          ////////console.logmessage)
          if (ress) {

            if (ress['soloDati']) {

              //let desc = "?$filter=((contains(tolower(descrizione)," + "'" + ress['localita'].toLowerCase() + "')))"
              let desc = "?$filter=( descrizione eq '" + ress['localita'] + "' )";
              this.anagraficaService.getElenco('Comune', '', desc).then(ree => {

                if (ree['items']) {


                  this.formSoggetto.formEdit.instance.updateData('istatComune', ree['items'][0]['id']);
                  this.formSoggetto.formEdit.instance.updateData('comune', ree['items'][0]['descrizione']);
                  this.formSoggetto.formEdit.instance.updateData('stato', 'IT');
                  this.formSoggetto.formEdit.instance.updateData('cap', ree['items'][0]['cap']);
                }

              })


              this.formSoggetto.formEdit.instance.updateData('ragioneSociale', ress['ragione_Sociale']);
              this.formSoggetto.formEdit.instance.updateData('isoFiscale', 'IT');
              this.formSoggetto.formEdit.instance.updateData('siglaProvincia', ress['prov']);
              this.formSoggetto.formEdit.instance.updateData('indirizzo', ress['indirizzo']);
              this.formSoggetto.formEdit.instance.updateData('comune', ress['localita']);
              this.formSoggetto.formEdit.instance.updateData('partitaIVA', ress['tax']);
              this.formSoggetto.formEdit.instance.updateData('codiceFiscale', ress['vat']);
              this.formSoggetto.formEdit.instance.updateData('pec', ress['pec']);
              //this.formSoggetto.formEdit.instance.updateData('cap', ress['cap']);
              this.formSoggetto.formEdit.instance.updateData('civico', ress['civico']);

            }
            if (ress['soloPec']) {
              this.formSoggetto.formEdit.instance.updateData('pec', ress['pec']);

            }
            this._overlaySidePanelService.close()
          }


        })

      }, 300)
    }


    ////////console.log(e)
    if (e.name == 'ottieniCoordinate') {

      if (this.formSoggetto.formEdit.formData['latidudine'] < -90 || this.formSoggetto.formEdit.formData['latidudine'] > 90) {
        alert('Per la latitudine specificare un numero compreso tra -90 e 90', 'Attenzione');
        return;
      }

      if (this.formSoggetto.formEdit.formData['longitudine'] < -180 || this.formSoggetto.formEdit.formData['longitudine'] > 180) {
        alert('Per la longitudine specificare un numero compreso tra -180 e 180', 'Attenzione');
        return;
      }


      console.warn(e);

      let address = e.data.indirizzo.concat(' ' + e.data.civico) + ',' + e.data.cap + ' ' + e.data.comune + ' ' + e.data.siglaProvincia
      this._overlaySidePanelService.setTitle("Coordinate Geografiche");
      let data = [
        {
          destComponent: 'AnaSoggetto',
          traceMessage: 'ottieniCoordinate',
          dati: (e.data.latidudine && e.data.longitudine) ? { lat: e.data.latidudine, lng: e.data.longitudine, address: address } : address
        }
      ]
      this._overlaySidePanelService.setTitle("Ottieni Coordinate");
      this._overlaySidePanelService.sendDataToComponent(data);

      this._overlaySidePanelService.setToolBarVisible(false)

      this._overlaySidePanelService.setContent(NicaMapsComponent);
      this._overlaySideFormService.setPopupWidth(850);
      this._overlaySideFormService.setPopupHeight(870);
      setTimeout(() => {

        (this._overlaySideFormService._hrefComponent.instance.coordinateEmitter as EventEmitter<any>).subscribe(
          (coordinate) => {

            console.warn(coordinate);

            if (coordinate) {
              this.formSoggetto.formEdit.instance.updateData('latidudine', "" + coordinate.lat());
              this.formSoggetto.formEdit.instance.updateData('longitudine', "" + coordinate.lng());
              this._overlaySideFormService.close();
            }
            else if (typeof coordinate == "undefined") {

              console.warn("DEVO CHIUDERE");
              this._overlaySideFormService.close();
            }
          }

        )

      }, 300);
      this._overlaySidePanelService.show();

    }



    if (e.name == 'submittedEditOk') {
      let data = e.formData;
      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });



      }

      ///Questa cosa se l'ho fatta non va bene fatta così quindi appena ho un pò di tempo la commento e vedo che succede.
      let template = this.template
      if (this.SubjectCall == 'lotto') {
        template = 'grid'
      }
      if (this.SubjectCall == 'magazzinorifiuti') {
        template = 'grid'
      }
      if (this.SubjectCall == 'autista') {
        template = 'grid'
      }
      if (this.SubjectCall == 'cantiere') {
        template = 'grid'
      }

      this.refreshPage(data, 'Modifica', this.SubjectCall, template);
      return
    }

    if (e.name == 'submittedInsertOk') {
      let data = e.formData;
      this.id = data[this.masterKey]
      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });



      }
      if (this.id)
        this.filterID['isEdit'] = true;

      let template = this.template
      if (this.SubjectCall == 'lotto') {
        template = 'grid'
      }
      if (this.SubjectCall == 'magazzinorifiuti') {
        template = 'grid'
      }
      if (this.SubjectCall == 'autista') {
        template = 'grid'
      }
      if (this.SubjectCall == 'cantiere') {
        template = 'grid'
      }

      this.refreshPage(data, 'Modifica', this.SubjectCall, template);
      return


    }

    if (e.eventName == 'submittedInsertOk') {

      this.id = e[this.masterKey];

      let data = e;
      
      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });



      }

      if (this.SubjectCall == 'soggetto') {
        this.refreshPage(e, 'Modifica', this.SubjectCall, 'form');

        const customMessage = custom({
          title: "Attenzione!",
          messageHtml: "Anagrafica soggetto salvata, inserisci l'unica locale...",

        })

        customMessage.show()

        setTimeout(() => {

          this.refreshPage([], 'Inserisci', 'sede', 'form');
          customMessage.hide()
        }, 1500);


        return


      }
      this.refreshPage(e, 'Modifica', this.SubjectCall, 'form');
      return


    }

    if (e.eventName == 'submittedEditOk') {


      let data = this.formSoggetto.dataSet;

      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });



      }

      this.refreshPage(data, 'Modifica', this.SubjectCall, 'form');
      return



    }

    if (e.name == 'return') {
      
      const copyF = this.filterID;

      //Se nei filtri ho movimento true allora chiudi la pagina e torna ai movimenti
      if(copyF['movimento']){
        e.event = 5
        this.buttonEmitted(e);
        return
      }
      let data = [];

      /**Gestisco i queryurl Filtri in Base al filtri iniziali**/

      if (this.anagraficaDati[0]['configuration']['queryFilter']) {

        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        let data
        if (typeof this.formSoggetto != 'undefined') {
          data = this.formSoggetto.dataSet
        } else {
          data = this.formAnagrafica.dataSet
        }

        //let data = this.filterID
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            //this.filterID[idTab['key']]=data[idTab['value']]
            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;

          }
        });


      }

      this.refreshPage('', 'Elenco', this.SubjectCall, 'grid');
      return

    }

    if (e.evento == 'coordinateGeografiche') {
      alert('Funzione non ancora disponibile', 'Attenzione!')
    }
    if (e.event == 'copiaDatiAzienda') {

      const icon = e.component.option('icon');

      if (icon == 'glyphicon mdi mdi mdi-checkbox-marked') {

        this.formSoggetto.formEdit.instance.updateData('descrizione', '');
        this.formSoggetto.formEdit.instance.updateData('indirizzo', '');
        this.formSoggetto.formEdit.instance.updateData('civico', '');
        this.formSoggetto.formEdit.instance.updateData('comune', '');
        this.formSoggetto.formEdit.instance.updateData('istatComune', '');
        this.formSoggetto.formEdit.instance.updateData('cap', '');
        this.formSoggetto.formEdit.instance.updateData('siglaProvincia', '');
        this.formSoggetto.formEdit.instance.updateData('stato', '');

        e.component.option('icon', 'glyphicon mdi mdi-checkbox-blank-outline');
        return

      } else {

        const data = e.data
        let filter = data['idSoggetto']

        this.anagraficaService.getValue('soggetto', filter, '').then(res => {

          this.formSoggetto.formEdit.instance.updateData('descrizione', res['ragioneSociale']);
          this.formSoggetto.formEdit.instance.updateData('indirizzo', res['indirizzo']);
          this.formSoggetto.formEdit.instance.updateData('civico', res['civico']);
          this.formSoggetto.formEdit.instance.updateData('comune', res['comune']);
          this.formSoggetto.formEdit.instance.updateData('istatComune', res['istatComune']);
          this.formSoggetto.formEdit.instance.updateData('cap', res['cap']);
          this.formSoggetto.formEdit.instance.updateData('siglaProvincia', res['siglaProvincia']);
          this.formSoggetto.formEdit.instance.updateData('stato', res['stato']);

          e.component.option('icon', 'glyphicon mdi mdi mdi-checkbox-marked')
        })
        return
      }


    }

    if (e.name == 'formDataChanged') {
      this.tempData = e.formDataChanged

      return

    }

    if (e.name == 'formDataInit') {
      this.currentElement = e.formData
      //this.SetToolbarButtons(this.serviceButtonsArray, e.formData);
    }


    if (e.name == 'returnButton') {
      e.component.option('text', "Ritorna all'elenco")
    }

    if (e.name == 'formContentInitializzed') {

      this.SetToolbarButtons(this.serviceButtonsArray, e.formData);

    }

  }

  formInitializzed(event) {
    this.SetToolbarButtons(this.serviceButtonsArray, event.formData);
  }

  emettiChiusuraCaption(e) {

    //console.log('emettiChiusuraCaption', e)

    //N.B La chiusura dei componenti in una app-caption (come footer) 
    //è demandata ai componenti stessi 
    if (e == 'closePopUpOverlay') {


    }


    if (e == 'close') {
      let event = { event: 5 }
      this.buttonEmitted(event)
    }

    if (e == 'closeToolbar') {

      if (!this.isOpen) {
        this.openToolBar()
      } else {
        this.closeToolBar()
      }


    }
    if (e == 'ritorna') {

      this.returnPrevUrl()


    }

    /* if (e == 'return') {
      this.showFormEdit = false
    }

    if (e == 'sfoglia') {
      this.showFormEdit = false
    }

    if (e == 'nuovo') {





    } */
  }

  openToolBar(event?) {
    if (typeof event != 'undefined') {
      event.preventDefault();
      event.stopPropagation();
    }

    this.InAttesaOpen = true;
    this.timeInterval = setTimeout(() => {
      if (!this.isOpen && this.InAttesaOpen)

        this.isOpen = true
    }, 100);



  }

  closeToolBar(event?) {

    if (typeof event != 'undefined') {
      event.preventDefault();
      event.stopPropagation();
    }
    this.InAttesaOpen = false;
    clearTimeout(this.timeInterval);
    setTimeout(() => {
      if (this.isOpen)
        this.isOpen = false

    }, 100);


  }

  toolbarEvent($event) {


    /* if(this.isOpen){
       this.closeToolBar()
     }else{
       this.openToolBar()
     }*/


  }

  buttonEmitted(em) {


    if (em.infoButton == 'grigliaDropDownButtonInit') {

      const buttons = em.buttons;
      const dataGrid = em.data;
      const componentMenu = em.componentMenu;

      ////console.log('grigliaDropDownButtonInit', buttons)
      ////console.log('grigliaDropDownDataGrid', dataGrid);
      ////console.log('grigliaDropDownComponent', componentMenu)
      this.SetToolbarButtons(this.serviceButtonsArray, dataGrid, componentMenu, em.componentDrop);

      componentMenu.option('items', this.buttonToolbarUp)
      return;

    }

    //console.log('buttonEmitted',em)

    let datiGriglia
    if (em.infoButton) {


      datiGriglia = em.datiGriglia
      em = em.infoButton


    }

    if (em.event == 0 && this.InviaA) {

      let messaggioChiusura: messagefromComponent = {
        codeMessage: 1,
        destComponent: this.InviaA,
        traceMessage: em.value
      }
      this.userComponentService.emitMessage(messaggioChiusura);
    }

    if (em.event == 1) {
      let currentElement
      let queryString = '';
      let values = {}
      if (this.template == 'form') {
        currentElement = typeof this.formSoggetto != 'undefined' ? this.formSoggetto.dataSet : this.formAnagrafica.dataSet
      } else if (this.template == 'grid') {
        if (datiGriglia) {
          currentElement = datiGriglia;
        } else {
          currentElement = this.filterID;
        }
      } else if (this.template == 'dynamicGrid') {
        currentElement = this.dynamicComponent.datasource;
      } else {
        currentElement = this.filterID
      }

      if (typeof em.queryString != 'undefined') {
        let myqueryString = em.queryString;
        for (let x in currentElement) {
          if (myqueryString.includes(x)) {
            myqueryString = myqueryString.replace('$' + x, currentElement[x])
          }
        }
        queryString = myqueryString
      }

      if (typeof em.costantValue != 'undefined') {

        const costantValue = em.costantValue;

        costantValue.forEach(element => {
          let keyEle = element['key'];
          let val = ''
          if (typeof currentElement[element['value']] != 'undefined') {
            val = currentElement[element['value']]
          } else {
            val = element['value']
          }

          values = { ...values, [keyEle]: val }
        })
      }

      let InstanceDatadata =
      {
        queryString: queryString,
        dataJson: values,

      }

      let dataTosend = [{
        dati: currentElement
      }];



      this.openComponentInPopUP(em['componentName'], dataTosend, InstanceDatadata, '800', em['name'],false,false);

      //this.openFunction(data)
    }
    if (em.event == 2) {
      alert('Funzione non disponibile, in lavorazione', 'Attenzione!')
    }

    if (em.event == 3) {

      let template = em.templateComponent;
      let currentElement;
      let currentNav;
      let event = 'Elenco';
      if (this.template == 'form') {
        if (typeof this.formSoggetto == 'undefined') {
          currentElement = this.formAnagrafica.dataSet
        } else {
          currentElement = this.formSoggetto.formEdit.formData
        }

      } else if (this.template == 'grid') {
        if (datiGriglia) {
          currentElement = datiGriglia;
        } else {
          currentElement = this.filterID;
        }
      } else if (this.template == 'dynamicGrid') {
        currentElement = this.dynamicComponent.datasource;
      } else {
        currentElement = this.filterID
      }


      const id = this.idBreadcrumbGroup ? this.idBreadcrumbGroup : this.SubjectCall


      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof currentElement[idTab['value']] != 'undefined') {

            //this.filterID[idTab['key']]=data[idTab['value']]
            newItem = { ...this.filterID, [idTab['key']]: currentElement[idTab['value']] };


            this.filterID = newItem;
          }
        });



        ////console.log(this.filterID)
      }


      //Pezzotto maligno ma utile, rimuove l'ultimo livello dopo L'unità locale  
      if (this.SubjectCall == 'sede') {
        if (this.breadcrumbNavigation.length >= 3) {
          const id = this.SubjectCall;
          this.userComponentService.removeLastItemComponentNavigation(this.currentTabId);
        }


      }



      const buttonParams = em
      this.refreshPage(currentElement, event, em.service, template, buttonParams, buttonParams.componentName);
      if (!this.isOpen) {
        this.openToolBar()
      } else {
        this.closeToolBar()
      }

    }

    if (em.event == 4) {


      if (em.value == '') {

        return
      }

      let datajS
      let currentEl

      if (this.template == 'form') {
        currentEl = this.formSoggetto.formEdit.formData
      } else if (this.template == 'grid') {
        if (datiGriglia) {
          currentEl = datiGriglia;
        } else {
          currentEl = this.filterID;
        }
      } else if (this.template == 'dynamicGrid') {
        currentEl = this.dynamicComponent.datasource;
      } else {
        currentEl = this.filterID
      }
      if (em.costantValue) {



        const costantValue = em.costantValue

        costantValue.forEach(res => {
          if (typeof currentEl[res['value']] != 'undefined') {
            datajS = { ...datajS, [res['key']]: currentEl[res['value']], }
          } else {
            datajS = { ...datajS, [res['key']]: this.filterID[res['value']], }
          }


        })

      }


      let dataToSend = JSON.stringify(datajS);


      let queryFilter = JSON.stringify(this.filterID);

      const navigationParams = {

        api: this.apiset,
        service: em.service,
        masterKey: 'id',
        filter: queryFilter,
        queryFilter: JSON.stringify(this.queryFilter),
        descEvent: em.text,
        templateView: em.templateComponent,
        titoloDaPortare: '',
        data: dataToSend,
        prevUrl: this.previusUrl,
        currentTabId: this.currentTabId,
        currentTabName: this.currentTabName,
        componentName: em.componentName

      }

      this.router.navigate(
        [em.path],
        {
          queryParams: navigationParams,
          skipLocationChange: true,
          replaceUrl: true
        }
      ).then(res => {

      })
    }
    if (em.event == 5) {

      ////console.log('console', em);

      const data = this.filterID;
      let dataJS = this.filterID;
      let datas
      
      if (em.costantValue) {

        const costantValue = em.costantValue

        costantValue.forEach(res => {

          //valori statici da passare
          datas = { ...dataJS, [res['key']]: res['value'] }

        })

      }



      const cUrl = this.router.url.split('?')[0];


      const navigationParams = {
        id: this.id,
        masterKey: 'id',
        api: this.apiset,
        service: this.SubjectCall,
        filter: this.params.filter,
        data: this.params.data,
        currentTabId: this.currentTabId,
        currentTabName: this.currentTabName,
        componentName: this.currentTabName,
        close: true

      }

      if (typeof this.itemData != 'undefined') {
        this.userComponentService.destroyCurrentOpenPopUpByGuid(this.currentTabId);
        this.userComponentService.removeNavigationComponent('', this.currentTabId)



        let closeData = {
          name: 'closeTab',
          service: this.SubjectCall,
          filterData: this.filterID
        }

        this.onAllEvent.emit(closeData)

        return
      }

      this.router.navigate(['/'], {
        skipLocationChange: false,
        replaceUrl: true
      }).then(() => {

        // Forzo a naviagare verso questa url per aggiornare i dati. 

        //sono costretto a ricaricare in maniera forzata il componente in attesa di idee
        let navigationExtras: NavigationExtras = {
          queryParams: navigationParams,
          skipLocationChange: false,
          replaceUrl: true
        };
        this.router.navigate([cUrl], navigationExtras);



      });

    }
    /*
    if (em.event == 7) {
      this.popupVisibleForm = !this.popupVisibleForm
    }
    */
  }

  setVariableDynamicGrid() {
    ////console.log('filterGrid', this.filterGrid);
    ////console.log('filterID', this.filterID['idAutorizzazione']);

    this.filterKey = this.filterID['idAutorizzazione'];
    this.campo = {

      type: 'campoComponent',
      labelVisible: false,
      colSpan: "1",
      dataField: 'AutorizzazioneAreaCer',
      validation: [{
        type: 'required',
        message: "My custom message"
      }],
      colVisible: false,
      width: '1700px',

      dynamic: {
        dataSource: 'autorizzazionecer',
        autocomplete: false,
        checkValue: {
          checkValueMessage: '',
          forceInsert: false
        },
        valueExpr: '',
        campoTabRif: 'id', //In edit o in insert sarà sempre l'id che mi verrà restituito dalle API
        displayExpr: 'descrizione',
        caption: "Lista Autorizzazioni EER Zona",
        filter: '',

        componentType: 'dynamicGrid',

        enableEditor: true,
        settingGrid: {
          campoTabRif: 'idAutorizzazione', //è il campo di rif. con il quele effettuare le operazioni di insert, edit e delete della griglia.
          masterKey: 'cer',
          keyUnique: '',
          mode: 'cell',
          remoteOperations: false,
          hoverStateEnabled: true,
          rowAlternationEnabled: true,
          repaintChangesOnly: true,
          allowUpdating: true,
          allowDeleting: true,
          allowAdding: false,
          height: 505,
          showFilterSearch: false,
        }

      }


    }


  }

  emittedDynamicGridInit(event) {
    const dataGrid = event.component.getDataSource().items

    //this.SetToolbarButtons(this.serviceButtonsArray, dataGrid);
  }

  messageFromComponent() {
    this.userComponentService.castMessage.subscribe((message: messagefromComponent) => {



      if (message.destComponent == 'AnaSoggetto' && message.traceMessage == 'infoCF' || message.destComponent == 'AnaSoggetto' && message.traceMessage == 'infoPiva') {

        this._overlaySidePanelService.close();
        ////////console.logmessage)
        if (message.Data) {

          if (message.Data.Items['soloDati']) {

            let desc = "?$filter=((contains(tolower(descrizione)," + "'" + message.Data.Items['localita'].toLowerCase() + "')))"

            this.anagraficaService.getElenco('Comune', '', desc).then(ree => {

              if (ree['items']) {


                this.formSoggetto.formEdit.instance.updateData('istatComune', ree['items'][0]['id']);
                this.formSoggetto.formEdit.instance.updateData('stato', 'IT');
              }

            })


            this.formSoggetto.formEdit.instance.updateData('ragioneSociale', message.Data.Items['ragione_Sociale']);
            this.formSoggetto.formEdit.instance.updateData('isoFiscale', 'IT');
            this.formSoggetto.formEdit.instance.updateData('siglaProvincia', message.Data.Items['prov']);
            this.formSoggetto.formEdit.instance.updateData('indirizzo', message.Data.Items['indirizzo']);
            this.formSoggetto.formEdit.instance.updateData('comune', message.Data.Items['localita']);
            this.formSoggetto.formEdit.instance.updateData('partitaIVA', message.Data.Items['tax']);
            this.formSoggetto.formEdit.instance.updateData('codiceFiscale', message.Data.Items['vat']);
            this.formSoggetto.formEdit.instance.updateData('pec', message.Data.Items['pec']);
            this.formSoggetto.formEdit.instance.updateData('cap', message.Data.Items['cap']);
            this.formSoggetto.formEdit.instance.updateData('civico', message.Data.Items['civico']);
            this.formSoggetto.formEdit.instance.updateData('stato', 'IT');

          }
          if (message.Data.Items['soloPec']) {
            this.formSoggetto.formEdit.instance.updateData('pec', message.Data.Items['pec']);

          }

        }


      }

      else if (message.destComponent == 'AnaSoggetto' && message.traceMessage == 'chiudiInfoImpresa') {

        this._overlaySidePanelService.close();

      }



    })

  }

  gridEvent(e) {
// console.log('stampo event',e)
    if (e.name == "onInitNewRow") {
      this.onAllEvent.emit(e)
    }

    if (e.name == "onInitilized") {

      this.onAllEvent.emit(e);

    }
    if (e.name == "masterDetailInitilized") {


      this.onAllEvent.emit(e)
    }

    if (e.name == "masterDetailContentReady" || e.componentName === "dettaglio1") {
      console.log('stampo event',e)
      //e.masterThis.griglia.instance.columnOption('tipoAttivita', 'visible', false);


      let items = e&&e.component&&e.component.getDataSource().items();

      if(items){
        let newData = items.forEach((itm, i) => {
        if (typeof itm.items != 'undefined') {
          itm.items.map((ppp, c) => {
            let tipoAttivita = []

            if (itm.idSedeRentri !== null) {
              tipoAttivita.push({
                class: 'rentri-bg me-1',
                value: 'R'
              })

            }

            if (ppp.isProduttore) {
              tipoAttivita.push(
                {
                  class: 'produttore-bg me-1',
                  value: 'P'
                }
              )

            }
            if (ppp.isTrasportatore) {

              tipoAttivita.push(

                {
                  class: 'trasportatore-bg me-1',
                  value: 'T'
                }

              )

            }

            if (ppp.isSmaltitore) {

              tipoAttivita.push(
                {
                  class: 'destinatario-bg me-1',
                  value: 'D'
                }
              )

            }

            if (ppp.isIntermediario) {

              tipoAttivita.push({
                class: 'intermediario-bg ',
                value: 'I'
              })

            }

            ppp.tipoAttivita = tipoAttivita
          })
        } else {

          let tipoAttivita = []

          if (itm.idSedeRentri !== null) {
              tipoAttivita.push({
                class: 'rentri-bg me-1',
                value: 'R'
              })

            }

          if (itm.isProduttore) {
            tipoAttivita.push(
              {
                class: 'produttore-bg me-1',
                value: 'P'
              }
            )

          }
          if (itm.isTrasportatore) {

            tipoAttivita.push(

              {
                class: 'trasportatore-bg me-1',
                value: 'T'
              }

            )

          }

          if (itm.isSmaltitore) {

            tipoAttivita.push(
              {
                class: 'destinatario-bg me-1',
                value: 'D'
              }
            )

          }

          if (itm.isIntermediario) {

            tipoAttivita.push({
              class: 'intermediario-bg ',
              value: 'I'
            })

          }

          itm.tipoAttivita = tipoAttivita

        }



      });
      }


      // e.component.customizeColumns = (col) => {
      //   ////console.log('customizeColumns', col)
      // };


      /* isIntermediario
      isProduttore
      isSmaltitore
      isTrasportatore */

      /* if(e.data.isProduttore){
        e.component.set(e.rowIndex, 'tipoAttivita', 'Produttore');
      } */
      //}

    }
    if (e.name == "masterDetailSelection") {


      e.event.stopPropagation()
      e.event.preventDefault();
      this.onAllEvent.emit(e)

    }

    // if (e.name == "onContentReady" && e.componentName == 'sede') {
    //   //e.masterThis.griglia.instance.columnOption('tipoAttivita', 'visible', false);


    //   let items = e.component.getDataSource().items();

    //   let newData = items.forEach((itm, i) => {
    //     if (itm.items) {

    //       itm.items.map((ppp, c) => {
    //         let tipoAttivita = []

    //         if (itm.idSedeRentri !== null) {

    //         tipoAttivita.push({
    //           class: 'rentri-bg me-1',
    //           value: 'R'
    //         })

    //       }
          
    //         if (ppp.isProduttore) {
    //           tipoAttivita.push(
    //             {
    //               class: 'produttore-bg me-1',
    //               value: 'P'
    //             }
    //           )

    //         }
    //         if (ppp.isTrasportatore) {

    //           tipoAttivita.push(

    //             {
    //               class: 'trasportatore-bg me-1',
    //               value: 'T'
    //             }

    //           )

    //         }

    //         if (ppp.isSmaltitore) {

    //           tipoAttivita.push(
    //             {
    //               class: 'destinatario-bg me-1',
    //               value: 'D'
    //             }
    //           )

    //         }

    //         if (ppp.isIntermediario) {

    //           tipoAttivita.push({
    //             class: 'intermediario-bg ',
    //             value: 'I'
    //           })

    //         }

    //         ppp.tipoAttivita = tipoAttivita
    //       })

    //     } else {

    //       let tipoAttivita = [];
    //       if (itm.idSedeRentri !== null) {

    //         tipoAttivita.push({
    //           class: 'rentri-bg me-1',
    //           value: 'R'
    //         })

    //       }

    //       if (itm.isProduttore) {
    //         tipoAttivita.push(
    //           {
    //             class: 'produttore-bg me-1',
    //             value: 'P'
    //           }
    //         )

    //       }

    //       if (itm.isTrasportatore) {

    //         tipoAttivita.push(

    //           {
    //             class: 'trasportatore-bg me-1',
    //             value: 'T'
    //           }

    //         )

    //       }

    //       if (itm.isSmaltitore) {
    //         tipoAttivita.push(
    //           {
    //             class: 'destinatario-bg me-1',
    //             value: 'D'
    //           }
    //         )
    //       }

    //       if (itm.isIntermediario) {

    //         tipoAttivita.push({
    //           class: 'intermediario-bg ',
    //           value: 'I'
    //         })

    //       }

    //       itm.tipoAttivita = tipoAttivita

    //     }
    //   });




    // }

        if (e.name === "onCellPrepared" && e.componentName === 'sede') {
      if (e.dataField === 'tipoAttivita') {
        let tipoAttivita = [];
        if (e.data) {
          if (e.data.idSedeRentri !== null) {
            tipoAttivita.push({
              class: 'badge rentri-bg me-1',
              value: 'R'
            })

          }

          if (e.data.isProduttore == 1) {
            tipoAttivita.push(
              {
                class: 'badge produttore-bg me-1',
                value: 'P',
                hint: 'Produttore'
              }
            )
          }
          if (e.data.isTrasportatore == 1) {
            tipoAttivita.push(
              {
                class: 'badge trasportatore-bg me-1',
                value: 'T',
                hint: 'Trasportatore'
              }
            )
          }
          if (e.data.isSmaltitore == 1) {
            tipoAttivita.push(
              {
                class: 'badge destinatario-bg me-1',
                value: 'S',
                hint: 'Smaltitore'
              }
            )
          }
          if (e.data.isIntermediario == 1) {
            tipoAttivita.push(
              {
                class: 'badge intermediario-bg me-1',
                value: 'I',
                hint: 'Intermediario'
              }
            )
          }
          e.cellElement.innerHTML = tipoAttivita.map((item) => `<span class="${item.class}" title="${item.hint || ''}">${item.value}</span>`).join('');
        }
      }
    }

    if (e.name == "onEditorPrepared") {

      e.cancel = true;
      let data = e.data
      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });



      }
      this.filterID['isEdit'] = true;
      e.descEvent = 'Modifica';
      this.refreshPage(e.data, 'Modifica', this.SubjectCall, 'form')
    }

    if (e.name == "onInitNewRow") {


      ////console.log('onInitNewRow', this.filterID)

      e.cancel = true;
      e.descEvent = 'Inserisci';
      this.filterID['isEdit'] = false;

      //this.formSoggetto.formRefresh()
      this.refreshPage('', e.descEvent, this.SubjectCall, 'form')
    }


    if (e.name == 'onSelectionChanged') {
      e.event.stopPropagation()
      e.event.preventDefault();
      this.onAllEvent.emit(e)

    }

    if (e.name == 'masterDetailInsert') {

      e.cancel = true;
      e.cancellaRefresh = false
      e.event.stopPropagation()
      e.event.preventDefault();

      this.onAllEvent.emit(e);

      if (e.cancellaRefresh) {
        return
      }

      e.descEvent = 'Inserisci';
      this.filterID['isEdit'] = false;
      const data = e.data;
      const detailRif = e.detailRif[0];

      const detailDataForm = this.templateService.getService(this.SubjectCall);

      if (detailDataForm[0]['configuration']['queryFilter']) {
        let arrayIdRif = detailDataForm[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });



      }
      this.filterID['isEdit'] = false;

      let pathUrl = 'main/' + detailRif.path
      //console.log('masterDetailInsert-->', e);
      this.refreshPage('', '', detailRif['service'], 'form', '', detailRif.componenName, pathUrl)

      //this.refreshPage('', e.descEvent, this.SubjectCall, 'form')
    }

    if (e.name == 'masterDetailEdit') {

      e.cancel = true;

      this.onAllEvent.emit(e);
      if (e.cancellaRefresh) {
        return
      }

      //console.log('masterDetailEdit', e)
      // //console.log('masterThis', e.masterThis.griglia.instance.getSelectedRowKeys())

      let data = e.data

      /**Gestisco i queryurl Filtri in Base al Edit**/
      const detailDataForm = this.templateService.getService(e.detailRif[0]['service']);

      if (detailDataForm[0]['configuration']['queryFilter']) {
        let arrayIdRif = detailDataForm[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });



      }
      this.filterID['isEdit'] = true;

      const detailRif = e.detailRif[0]

      let pathUrl = 'main/' + detailRif.path

      this.refreshPage(data, '', e.detailRif[0]['service'], 'form', '', detailRif.componenName, pathUrl)
      return

      let queryFilter = JSON.stringify(this.filterID);

      const navigationParams = {

        api: detailDataForm[0]['configuration']['api'],
        service: detailDataForm[0]['configuration']['service'],
        masterKey: detailDataForm[0]['configuration']['masterKey'],
        filter: queryFilter,
        queryFilter: JSON.stringify(this.filterID),
        descEvent: '',
        templateView: 'form',
        titoloDaPortare: '',
        data: data,
        id: data.id,
        prevUrl: this.previusUrl,
        currentTabId: this.currentTabId,
        currentTabName: this.currentTabName,
        componentName: detailRif.componentName
      }

      this.router.navigate(
        ['main/' + detailRif.path],
        {
          queryParams: navigationParams,
          skipLocationChange: false,
          replaceUrl: true
        }
      ).then(res => {

      })
    }

    if (e.name == 'onRowExpanding') {
      //e.cancel = true;

      this.onAllEvent.emit(e);

    }
  }

  updateFilterGrid(queryString: string,griglia?): void {
    this.filterGrid = this.filterGrid.split('&')[0] + '&' + queryString;
    //localStorage.setItem('Filtri', JSON.stringify({ queryString }));
    if(typeof this.nicaAnagrafica != 'undefined') {
      this.nicaAnagrafica.refresh()
      return
    }
    griglia.refresh()
  }

  updateFilterIconColors(hasQuery: boolean): void {
    const color = hasQuery ? '#edcd5f' : '#023957';
    Array.from(document.getElementsByClassName('dx-icon export icon-filter')).forEach(
      icon => (icon as HTMLElement).style.color = color
    );
  }

  refreshPage(data, descEvent = '', service, template, buttonParams?, component?, pathUrl?) {

    if (typeof this.itemData != 'undefined') {
      //template = template == 'form'?'grid': template
      this.refreshData(data, descEvent = '', service, template, component);

      return
    }

    let titoloDaPortare
    let id

    if (typeof data != 'undefined' || data != '') {
      id = data['id'];
      //this.filterID['isEdit'] = true
    }

    let filter = ''
    let dataToSend = JSON.stringify(data);
    if (typeof this.filterID == 'object') {
      filter = JSON.stringify(this.filterID);
    }
    //let filterId = {...this.filterID};


    let cUrl = '';

    if (pathUrl) {
      cUrl = pathUrl
    } else {
      cUrl = this.router.url.split('?')[0];
    }


    let api = this.apiset;
    let componentName = component ? component : this.params.componentName

    if (buttonParams) {
      cUrl = buttonParams.path;
      api = buttonParams.api;
      componentName = buttonParams.componentName
    }



    const navigationParams = {
      id: id,
      api: api,
      service: service,
      masterKey: 'id',
      filter: filter,
      descEvent: descEvent,
      templateView: template,
      titoloDaPortare: titoloDaPortare,
      /* data: dataToSend, */
      prevUrl: this.previusUrl,
      currentTabId: this.currentTabId,
      currentTabName: this.currentTabName,
      componentName: componentName

    }

    this.router.navigate(['/'], {
      skipLocationChange: false,
      replaceUrl: true
    }).then(() => {
      // Forzo a naviagare verso questa url per aggiornare i dati. 

      //sono costretto a ricaricare in maniera forzata il componente in attesa di idee
      let navigationExtras: NavigationExtras = {
        queryParams: navigationParams,
        skipLocationChange: false,
        replaceUrl: false
      };
      this.router.navigate([cUrl], navigationExtras);

      /* const queryParams = navigationParams


      let nav = {
        title: this.breadcrumbCaption,
        cRouter: cUrl,
        params: queryParams,


      }

      this.userComponentService.setComponentNavigation(nav) */

      /* if(service=='soggetto' && template=='grid'){
        this.userComponentService.removeAllItemComponentFromID('soggetto',this.currentTabId)
      } */

    });
  }

  refreshData(data, descEvent = '', service, template, component?) {


    let titoloDaPortare
    let id

    if (typeof data != 'undefined' || data != '') {
      id = data['id'];
    }

    let dataToSend = JSON.stringify(data);

    let filter = JSON.stringify(this.filterID);

    let cUrl = this.router.url.split('?')[0];
    let api = this.apiset;
    let componentName = component ? component : this.currentTabName

    let currentPopupsSet = this.userComponentService.currentPopupsSet

    let index = currentPopupsSet.findIndex(rrrr => rrrr.id == this.currentTabId && rrrr.componentName == componentName)

    let guid = Math.random().toString().replace("0.", "");
    if (index >= 0) {
      guid = this.currentTabId;
    }


    const navigationParams = [{
      id: id,
      api: api,
      service: service,
      masterKey: 'id',
      filter: filter,
      descEvent: descEvent,
      templateView: template,
      titoloDaPortare: titoloDaPortare,
      data: dataToSend,
      prevUrl: this.previusUrl,
      currentTabId: guid,
      currentTabName: componentName,
      componentName: componentName,

    }]


    if (index >= 0) {

      guid = this.currentTabId;
      //this.resettaVariabiliGlobali()
      //this.setGlobalVariableFromParams(navigationParams[0]);

    }



    this.userComponentService.setNewPopUp(guid, componentName, navigationParams, null, null, null, false, false, null, 'bottom');
    this.userComponentService.removeNavigationComponent(service, componentName)



  }

  resettaVariabiliGlobali(): void {
    // Ottieni tutte le proprietà dell'istanza del componente
    const props = Object.getOwnPropertyNames(this);

    // Itera attraverso le proprietà e azzerale se non sono metodi o proprietà interne di Angular
    props.forEach(prop => {
      if (typeof this[prop] !== 'function' && !prop.startsWith('_') && prop !== 'constructor') {
        this[prop] = null;
      }
    });
  }

  buildDataToTake(dataForm, dataTake) {

    let values = this.filterID
    dataTake.forEach(element => {
      let keyEle = element['keyResult'];
      let val = element['valueToTake']
      if (typeof dataForm[element['valueToTake']] != 'undefined') {
        val = dataForm[element['valueToTake']]
      }

      values = { ...values, [keyEle]: val }
    })

    this.filterID = values
  }

  addDataToFilterID(dataForm, queryFilter) {

    let values = this.filterID
    queryFilter.forEach(element => {
      let keyEle = element['key'];
      let val = element['value']
      if (typeof dataForm[element['value']] != 'undefined') {
        val = dataForm[element['value']]
      }

      values = { ...values, [keyEle]: val }
    })

    this.filterID = values
  }

  openFunction(infoData) {

    /*
        {
    name: 'Documenti',
    icon: 'glyphicon icon-documenti-form',
    displayMode: 'in-line',
    service: 'allegati',
    api: 'Allegati',
    path: '',
    templateComponent: '',
    componentName: 'AllegatiComponent',
    costantValue: [
      { key: 'nomeTabella', value: 'soggetti' }
    ],
    hint: 'Lista allegati',
    event: '1',
    location: 'top',
    visible: true,
    disabled: false,
    wPopUp: "1000",
    hPopUp: "700"
  },
    */
    //////console.log("EM VALUE I ANA SOGGETTO ",infoData)
    if (!infoData[0].value) {
      alert('Funzione non disponibile', 'Attenzione!')
      return;
    }

    ////////console.log(em)

    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === infoData[0].infoButton.componentName);
    this._overlaySidePanelService.setTitle(infoData[0].infoButton.name);
    this._overlaySidePanelService.setContent(factoryClass);
    this._overlaySideFormService.setToolBarVisible(false)
    this._overlaySideFormService.setPopupWidth((infoData[0].infoButton.wPopUp) ? infoData[0].infoButton.wPopUp : 800);
    this._overlaySideFormService.setPopupHeight((infoData[0].infoButton.hPopUp) ? infoData[0].infoButton.hPopUp : 500);


    ////console.log("EM VALUE I ANA SOGGETTO ",infoData[0])
    this._overlaySidePanelService.sendDataToComponent(infoData);

    this._overlaySidePanelService.show();


    setTimeout(() => {


      //this._overlaySideFormService._hrefComponent.instance.class = 'soggetto-form';



      (this._overlaySideFormService._hrefComponent.instance.emittedData as EventEmitter<any>).subscribe(ress => {

        ////console.log('emittedData', ress);


        ////////console.logmessage)
        if (ress) {

          if (ress.data) {
            let emittedData = ress.data;

            if (emittedData[this.masterKey]) {
              delete emittedData[this.masterKey];
            }

            for (let x in emittedData) {

              if (this.formSoggetto.checkDataField(x)) {

                this.formSoggetto.formRefreshInputData(x, emittedData[x]);

                this._overlaySideFormService.close();

                notify({
                  message: 'Operazione completata',
                  height: 45,
                  width: 150,
                  position: 'center center'

                }, 'success', 3500);
              }

            }
            //emittedData

          }
        }
      }
      )

    }, 300)
  }

  public dateParse(dateTime) {
    let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
    let isMatch = dateType.test(dateTime);

    if (isMatch) {
      let date = new Date(dateTime)
      let month = ("0" + (date.getMonth() + 1)).slice(-2); month + 1
      let day = date.getDate().toString().padStart(2, '0');

      return date.getFullYear() + '-' + month + '-' + day;

    } else {
      return dateTime
    }
  }

  public dateParseIT(dateTime) {
    let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
    let isMatch = dateType.test(dateTime);

    if (isMatch) {
      let date = new Date(dateTime)
      let month = ("0" + (date.getMonth() + 1)).slice(-2); month + 1
      let day = date.getDate().toString().padStart(2, '0');

      return day + '/' + month + '/' + date.getFullYear();

    } else {
      return dateTime
    }
  }

  private formatDate(dateString: string, type: 'EN' | 'it' = 'EN'): string {

    const regExpISO: RegExp = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
    const regExpIT: RegExp = /(\d{1,2})([\/-])(\d{1,2})\2(\d{4})/;


    let isMatchISO = dateString.match(regExpISO);
    let isMatchIT = dateString.match(regExpIT);

    //Se nessuno dei 2 formati è valido
    if (!isMatchISO && !isMatchIT) {
      return undefined;
    }

    if (isMatchIT) {

      if (dateString.includes('-'))
        dateString = `${dateString.split('-')[2]}-${dateString.split('-')[1]}-${dateString.split('-')[0]}`;
      else if (dateString.includes('/'))
        dateString = `${dateString.split('/')[2]}-${dateString.split('/')[1]}-${dateString.split('/')[0]}`;
    }

    const date = new Date(dateString);

    // Formatta la data come necessario
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Mese è 0-based
    const day = date.getDate().toString().padStart(2, '0');
    if (type == 'EN') {
      return `${year}-${month}-${day}`;
    }

    if (type == 'it') {
      return `${day}-${month}-${year} `;
    }
  }

  buildFilterList(formData, isOr=false){
    let myqueryStrigOdata = []

    let queryStrigOdata:string = ''

        // for(let xin in formData){
        //   if(xin){

        //   }
        // }
        for(let xin in formData){
          let type = this.getTypeOfField(formData[xin]);
          let value = formData[xin];
          let dataField = xin
          if (typeof type != 'undefined') {
            if (this.builderOdataSearchString(dataField, type, value)) {
              myqueryStrigOdata.push(this.builderOdataSearchString(dataField, type, value))
            }
          }


        }


        if(myqueryStrigOdata.length>0){
          if(!isOr){
            queryStrigOdata = myqueryStrigOdata.join(' and  ')
          }else{
            queryStrigOdata = myqueryStrigOdata.join(' or  ')
          }
        }
       

        
        
        return queryStrigOdata
  }

  buildFilterList2(formData, isOr=false){

    let myqueryStrigOdataBooleanObject = [];
    let myqueryStrigOdataOthers = [];
    let queryStrigOdata:string = '';

        
    for(let xin in formData){
      let type = this.getTypeOfField(formData[xin]);
      let value = formData[xin];
      let dataField = xin;
      if (typeof type != 'undefined') {
          let filterString = this.builderOdataSearchString(dataField, type, value);
          if (filterString) {
              if (type.toLowerCase() === 'boolean' || type.toLowerCase() === 'object') {
                  myqueryStrigOdataBooleanObject.push(filterString);
              } else {
                  myqueryStrigOdataOthers.push(filterString);
              }
          }
      }
  }

  if(myqueryStrigOdataBooleanObject.length > 0){
      let booleanObjectQuery = myqueryStrigOdataBooleanObject.join(' or ');
      queryStrigOdata += booleanObjectQuery;
  }

  if(myqueryStrigOdataOthers.length > 0){
      let othersQuery = myqueryStrigOdataOthers.join(' and ');
      if (queryStrigOdata) {
          queryStrigOdata += ' and ' + othersQuery;
      } else {
          queryStrigOdata = othersQuery;
      }
  }

  return queryStrigOdata;
  }


  builderOdataSearchString(dataField, tipoCampo, value) {

    if (!value) {
      return null
    }

    //console.warn(searchType);

    switch (tipoCampo.toLowerCase()) {

      case 'text':
        
          return `(contains(tolower(${dataField}),'${value.toLowerCase()}'))`;
       
      case 'string':
        
          return `(contains(tolower(${dataField}),'${value.toLowerCase()}'))`;
        
      case 'number':
        let strToNumber = Number(value);

        if (!isNaN(strToNumber))
          return `(${dataField} eq ${strToNumber})`;


      case 'date':
      case 'dateTime':
        {
          let dataFormattata = this.formatDate(value)

          if (typeof dataFormattata !== 'undefined')
            return `(${dataField} eq ${dataFormattata})`;
        }

      case 'boolean':
        return  `(${dataField} eq ${value })`;
      case 'array':
        let stringQueryA = []
        value.forEach(val=>{
          if(typeof val ==='number')stringQueryA.push(`(${dataField} eq ${val}) `);
          if(typeof val ==='string')stringQueryA.push(`(contains(tolower(${dataField}),'${val.toLowerCase()}'))`);
        })
        return  stringQueryA.join(' or ')

     
      case 'object':
        let stringQuery = []
        for(let c in value){
          stringQuery.push(`(${c} eq ${value[c]}) `);
        } 
        return  stringQuery.join(' or ')

     

      default:
        /* if(typeof searchType == 'undefined' || searchType == 'contains')
          return `(contains(tolower(${dataField}),'${this.searchText.toLowerCase()}'))`;
        else
          return `(startswith(tolower(${dataField}),'${this.searchText.toLowerCase()}'))`; */


    }
  }

  getTypeOfField(value){

    if (value === null) {
        return 'null';
    }
    if (value === undefined) {
        return 'undefined';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    if (value instanceof Date) {
        return 'date';
    }
    if (typeof value === 'number') {
        return 'number';
    }
    if (typeof value === 'string') {
        return 'string';
    }
    if (typeof value === 'boolean') {
        return 'boolean';
    }
    if (typeof value === 'object') {
        return 'object';
    }
    return 'unknown';
  }

  getPrevItemComponentNavigation(id, currentTabId) {
    if (this.cronNavigation.length > 0) {
      const currentNav = this.userComponentService.getCurrentRouterNav(currentTabId);
      const currentItemIndex = currentNav[0].data.findIndex(items => items.id == id) - 1;
      //console.log('getPrevItemComponentNavigation', currentItemIndex)
      if (currentItemIndex >= 0) {
        return currentNav[0].data[currentItemIndex]
      } else {
        let cLast = currentNav[0].data.length - 1;
        let prev = cLast - 1
        if (prev >= 0)
          return currentNav[0].data[prev]
      }

      //currentNav[0].data.splice(-1);
      //this.navComponent.splice(-1);
      //this._componentRouter.next(currentNav)
    }
  }

  returnPrevUrl() {


    const copyF = this.filterID;
    
    if(typeof this.idBreadcrumbGroup != 'undefined' &&  this.SubjectCall != this.idBreadcrumbGroup){
      
      this.returnUrlBy();
      return
    }else if(copyF['movimento']){
      let e = { event: 5}
      this.buttonEmitted(e);
      return
    }

    

    let prevItemNavigation = this.getPrevItemComponentNavigation(this.SubjectCall, this.currentTabId)
    if (typeof prevItemNavigation == 'undefined') {
      prevItemNavigation = this.getPrevItemComponentNavigation(this.idBreadcrumbGroup, this.currentTabId)

    }



    setTimeout(() => {
      this.router.navigate(['/'], {
        skipLocationChange: true,
        replaceUrl: true
      }).then(() => {
        // Forzo a naviagare verso questa url per aggiornare i dati. 
        //è un pezzoto ma NicaAnagrafica non si aggiorna,
        //sono costretto a ricaricare in maniera forzata il componente in attesa di idee

        let navigationExtras: NavigationExtras = {
          queryParams: prevItemNavigation['params'],
          skipLocationChange: true,
          replaceUrl: true
        };
        this.router.navigate([prevItemNavigation['cRouter']], navigationExtras);

        this.userComponentService.removeLastItemComponentNavigation(this.params.currentTabId)

        //this.loader.hide()
      });
    }, 200);


    return
  }

  returnUrlBy(id?){

    this.userComponentService.componentRouter.forEach(res => {

      if (Array.isArray(res) && res.length > 0) {
        this.cronNavigation = res.filter(res => res.idTab == this.currentTabId)
      }

    })

    if (this.cronNavigation.length > 0) {

      let navigations = this.cronNavigation.filter(res => res.idTab == this.currentTabId)
      let navigation = navigations[0].data;
      
      let checkItemIdex = navigation.findIndex(n => n.id == this.idBreadcrumbGroup);

      if (checkItemIdex >= 0) {
        const nav = navigation[checkItemIdex]
        const cUrl = nav.cRouter


        const navigationParams = nav.params;

        this.router.navigate(['/'], {
          skipLocationChange: false,
          replaceUrl: true
        }).then(() => {
  
          // Forzo a naviagare verso questa url per aggiornare i dati. 
  
          //sono costretto a ricaricare in maniera forzata il componente in attesa di idee
          let navigationExtras: NavigationExtras = {
            queryParams: navigationParams,
            skipLocationChange: false,
            replaceUrl: true
          };
          this.router.navigate([cUrl], navigationExtras);
  
  
  
        });
      } 

    }
    return;
  }

  showingPopUp(e) {

    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    e.component.content().classList.add("formEditPopupContet"); //add class to content
    e.component.content().classList.add("bg-grey"); //add class to content
    e.component.content().classList.add("soggetto-form"); //add class to content

  }

  openComponentInPopUP(componentName: string, data:Array<any>=[], InstanceDatadata?, width: string = '', popupTitle?: string, showCaptionFooter: boolean = true, showCaptionHeader: boolean = true, position = 'center',help='-') {

    let guid = Math.random().toString().replace("0.", "");
    if (data.length > 0) {
      data[0].currentTabId = guid
    }
    //InstanceDatadata['guid']=guid

    this.userComponentService.setNewPopUp(guid, componentName, data, width, null, InstanceDatadata, showCaptionFooter, showCaptionHeader, popupTitle, position,help)
    return guid
  }

  closeComponentInPopUP() {

    this.userComponentService.closeOverlayForm();

  }

  queryStringByService(service, rowData, key) {
    const anagraficaConfig = this.templateService.getService(service)[0]['configuration'];

    let filterKey = anagraficaConfig[key];
    let returnFilter = filterKey;

    if (returnFilter.includes('$')) {
        for (let x in rowData) {
            if (returnFilter.includes(x)) {
                let regex = new RegExp('\\$' + x + '\\b', 'g');
                let matchFilter = returnFilter.match(regex);
                if (matchFilter) {
                    if (typeof rowData[x] !== 'undefined') {
                        returnFilter = returnFilter.replace(regex, rowData[x]);
                    }
                } else {
                    if (typeof rowData[x] !== 'undefined') {
                        const pattern = /\?id=\$/;
                        let reee = pattern.test(returnFilter);
                        if (reee) {
                            let espressioneRegolare = /\$/;
                            let nuovaStringa = returnFilter.replace(espressioneRegolare, rowData[x]);
                            returnFilter = nuovaStringa;
                        }
                    }
                }
            }
        }

        // Nuova gestione per filterKey che contiene solo "$" o "/$"
        if (filterKey === "/$" || filterKey === "$") {
            if (rowData['id']) {
                returnFilter = returnFilter.replace('$', rowData['id']);
            }
        }
    }

    if (filterKey !== returnFilter) {
        return returnFilter;
    } else {
        return null;
    }
  }

  resettaFiltroApplicato(key?){
    //this.loader.show()
    if (key){
      let filtriOBJ = JSON.parse(sessionStorage.getItem('Filtri'));
      delete filtriOBJ[key];
      sessionStorage.setItem('Filtri', JSON.stringify(filtriOBJ));
    }

    setTimeout(
      () => {

        for (let i = 0; i < document.getElementsByClassName('dx-icon export icon-filter').length; i++) {

          if ((document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).parentElement.parentElement.id == 'bottoneFiltroToolbar') {

            (document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).style.color = '#023957';

            break;
          }

        }
        
      }, 500);
      const anagraficaFilter = this.anagraficaDati.filter(r => r.configuration);
      this.impostaFiltroGriglia(null,anagraficaFilter)

    /* if (this.filterGrid.split('?').length > 1){
      
     
        let regexFilter =  /\$filter=\(.*?\)&/;
        //let regexFilter2 = /\$filter=(.*)/ ;
        let checkQuery = this.filterGrid.match(regexFilter);
        //let checkQuery2 = this.filterGrid.match(regexFilter2);
        if (checkQuery) {
          this.filterGrid =   this.filterGrid.replace(regexFilter, '');
          //this.filterGrid =   this.filterGrid.replace(regexFilter2, '');
        }
      
    } */

        setTimeout(() => {
          this.nicaAnagrafica.refresh();

          //this.loader.hide()
        }, 500);
   

  }

  checkAndRemoveDuplicates(arr,key) {
      const seenIds = new Set<string>();
      const result = [];

      for (const item of arr) {
          if (seenIds.has(item[key])) {
              alert(`Duplicato trovato: ${item[key]}`,'Attenzione!');
              continue; // Salta questo elemento se è un duplicato
          }
          seenIds.add(item[key]);
          result.push(item);
      }

      return result;
  }

}

